import { render, staticRenderFns } from "./BrandByTag.vue?vue&type=template&id=195b2f3e&"
import script from "./BrandByTag.vue?vue&type=script&lang=js&"
export * from "./BrandByTag.vue?vue&type=script&lang=js&"
import style0 from "./BrandByTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports